module.exports = __webpack_public_path__ + "img/aa1.4436cd72.svg";